<template>
  <v-layout column>
    <v-toolbar dense flat style="padding-left: 0; background: none">
      <v-toolbar-title class="pl-1 body-1">{{label}}</v-toolbar-title>
      <v-dialog
        v-model="dialog"
        persistent
        scrollable
        width="650"
      >
        <v-btn flat icon color="primary" slot="activator" @click="()=>{item={}; org={}; editIdx = null}">
          <v-icon>add</v-icon>
        </v-btn>
        <v-card>
          <v-card-text>
            <v-form v-model="formValid" ref="formRef">
              <v-container>
                <v-layout row wrap>

                  <v-flex xs8>
                    <x-org-select
                      :multiple="false"
                      label="归属单位"
                      :rules="rules.required"
                      v-model="org"
                    />
                  </v-flex>

                  <v-flex xs4>
                    <v-select
                      label="归属单位序号"
                      :items="rankValidItems"
                      :rules="rules.required"
                      v-model="item.order"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="dialog = false">取消</v-btn>
            <v-btn color="primary" @click.native="onOk">确定</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <v-data-table
      class="dense"
      :headers="headers"
      :items="value"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <td>{{props.item.order}}</td>
        <td class="text-xs-center">{{props.item.name}}</td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="onEdit(props.index, props.item)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <span>编辑</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="onDel(props.index)">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
            <span>删除</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
  </v-layout>
</template>
<script>
  import XOrgSelect from '@/components/global/OrgSelectForm'

  const orgURI = '/api/syst/dept/';

  export default {
    name: 'orgsEdit',
    props: ['value', 'label', 'hint'],
    components: {XOrgSelect},

    data() {
      return {
        headers: [
          {text: '排序', sortable: false, value: 'rank', width: 18},
          {text: '归属单位名称', align: 'center', sortable: false, value: 'name'},
          {text: '操作', align: 'center', sortable: false, value: 'dbid'}
        ],
        /**
         * 验证规则
         */
        rules: {
          required: [
            v => !!v || '必填项。'
          ]
        },

        dialog: false,
        item: {
          dbid: null,
          intelId: null,
          name: null,
          order: null
        },
        org: {
          name: null
        },
        editIdx: null,
        formValid: false,

        rankItems: [1, 2, 3, 4, 5, 6, 7, 8, 9,10,11,12,13,14,15,16,17,18,19,20]

      }
    },
    watch: {
      org: function (u) {
        Object.assign(this.item, u);
      }
    },
    computed: {
      rankValidItems() {
        const invalid = (this.value || []).map(v => v.order).filter (v => v !== this.item.order);
        return this.rankItems.filter((v, i, a) => !invalid.includes(v));
      }
    },
    methods: {
      onEdit(idx, it) {
        this.editIdx = idx;
        this.item = window.xutil.clone(it);
        this.org.name = this.item.name;
        this.dialog = true;
      },
      onOk() {
        if (this.$refs.formRef.validate()) {
          let orgs = window.xutil.clone(this.value);

          if (this.editIdx != null) {
            orgs[this.editIdx] = window.xutil.clone(this.item);
          } else {
            orgs.push(xutil.clone(this.item));
          }

          orgs.sort((a, b) => a.rank - b.rank);
          this.$emit('input', orgs);
          this.dialog = false;
        }
      },
      onDel(idx) {
        this.$emit('input', this.value.filter((v, i) => i !== idx))
      }
    }

  }
</script>
<style>
  div.menu__content.hide-list {
    display: none;
  }
</style>

